import React from "react";
import { Box } from "@mui/material";
import RelValGrid from "./RelValGrid";

const Dashboard = () => {
  return (
    <Box sx={{ p: 2 }}>
      <RelValGrid />
    </Box>
  );
};

export default Dashboard;
